import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

export const trackTrustBannerImpression = (label: string) => {
  deferTracking(() =>
    sendGAEvent({
      content_type: 'trust banner',
      event: 'custom_event',
      event_action: 'Impression',
      event_category: 'PDP Trust Banner',
      event_label: label,
      event_name: 'view_content',
      item_id: label,
    }),
  );
};
